import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import PreorderProducts from '../PreorderProducts'
import { AppState } from '../../../../reducers'
import { fetchAllProductBrands } from '../../../../actions/product/productBrandList'
import { fetchAllProductGroups } from '../../../../actions/product/productGroupList'
import { fetchAllProductSections } from '../../../../actions/product/productSectionList'
import { fetchAllProductSubgroups } from '../../../../actions/product/productSubgroupList'
import { ProductBrandListState } from '../../../../reducers/product/productBrandList'
import { ProductSectionListState } from '../../../../reducers/product/productSectionList'
import { ProductGroupListState } from '../../../../reducers/product/productGroupList'
import { ProductSubgroupListState } from '../../../../reducers/product/productSubgroupList'
import { Stack } from '@mui/material'
import { PreorderDataState } from '../../../../reducers/preorder/preorderData'
import { fetchPendingPreorder, fetchPreorder } from '../../../../actions/preorder/preorder'
import { SessionState } from '../../../../reducers/auth/session'
import { InfoCurrentPriceListState } from '../../../../reducers/infoCurrentPriceList'
import { fetchInfoCurrentPriceList, fetchPriceList } from '../../../../actions/currentPriceList'
import { PrepaymentDetailState } from '../../../../reducers/prepayment/prepaymentDetail'
import { fetchPrepayment } from '../../../../actions/prepayment/prepaymentDetail'
import { fetchUsePrepayment } from '../../../../actions/prepayment/usePrepaymentDetail'
import { UsePrepaymentDetailState } from '../../../../reducers/prepayment/usePrepaymentDetail'
import { fetchAllProducts } from '../../../../actions/product/productList'
import { ProductListState } from '../../../../reducers/product/productList'
import DeliveryLocation from '../../../../models/DeliveryLocation'
import { fetchProvinces } from '../../../../actions/deliveryLocation/provinceList'
import { ProvinceListState } from '../../../../reducers/province/provinceList'
//import { LocalityListState } from '../../../../reducers/locality/localityList';
//import { fetchLocalities } from '../../../../actions/deliveryLocation/localityList'
import { fetchPreorderSurplusProduct } from '../../../../actions/preorder/preorderProductList'
import { CountryDetailState } from '../../../../reducers/country/countryDetail'
import PreorderProduct from '../../../../models/PreorderProduct'
import { PreorderSurplusProductState } from '../../../../reducers/preorder/preorderSurplusProduct'
import { fetchCountry } from '../../../../actions/country/countryDetail'
import Country from '../../../../models/Country'
import { PreorderDetailListState } from '../../../../reducers/preorder/preorderDetailList'
import { fetchPreorderDetails } from '../../../../actions/preorder/preorderDetail'

interface Props {
  productBrandsList: ProductBrandListState
  productSectionsList: ProductSectionListState
  productGroupsList: ProductGroupListState
  productSubgroupsList: ProductSubgroupListState
  provinceList: ProvinceListState
  //localityList: LocalityListState
  currentPriceList: InfoCurrentPriceListState
  productList: ProductListState
  prepayment: PrepaymentDetailState
  usePrepaymentDetail: UsePrepaymentDetailState
  preoderSurplusProduct: PreorderSurplusProductState
  country: CountryDetailState
  preorder: PreorderDataState
  preorderDetail: PreorderDetailListState
  session: SessionState
}

export interface ProductRelations {
  brandId: number;
  sectionId: number;
  groupId: number;
  subgroupId: number;
}

interface LocationState {
  delivery: any
  prepaymentId: string;
}

const PreorderList: React.FC<Props> = ({ productBrandsList, productSectionsList, productGroupsList, productSubgroupsList, currentPriceList, productList, provinceList, /*localityList,*/ prepayment, usePrepaymentDetail, preorder, preorderDetail, country, preoderSurplusProduct, session }) => {
  const dispatch = useDispatch()

  const location = useLocation<LocationState>() //: { delivery: any, prepaymentId?: string, }}>()

  //const { delivery, prepaymentId} = location.state

  const [prepaymentId, setPrepaymentId] = useState<string | undefined>(undefined)
  const [deliveryData, setDeliveryData] = useState<DeliveryLocation | undefined>(undefined)

  const [productRelations, setProductRelations] = useState<ProductRelations[]>([])
  const [surplusProduct, setSurplusProduct] = useState<PreorderProduct | undefined>(undefined)
  const [surplusQty, setSurplusQty] = useState<number | undefined>(undefined)


  useEffect(() => {
    if (location && location.state && location.state.delivery)
      setDeliveryData(JSON.parse(location.state.delivery))
    if (location && location.state && location.state.prepaymentId)
      setPrepaymentId(location.state.prepaymentId)
    else
      setPrepaymentId('')
  }, [location])


  useEffect(() => {

    const handleSurplus = (preorderProducts: PreorderProduct[]) => {
      if (preorderProducts && preorderProducts.length > 0) {
        setSurplusProduct(preorderProducts[0])
      }
    }
    if (prepaymentId) {
      dispatch(fetchPrepayment(prepaymentId))
      dispatch(fetchUsePrepayment(prepaymentId))

      if (!surplusProduct) {
        dispatch(fetchCountry(session.countryId?.toString()!, (countryResponse: Country) => {
          setSurplusQty(countryResponse.surplusPrepaymentQty)
          const search = `?prepaymentId=${prepaymentId}&code=${countryResponse.surplusPrepaymentCode}`          
          dispatch(fetchPreorderSurplusProduct(search, handleSurplus))
        }
        ));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [dispatch, prepaymentId])

  useEffect(() => {
    dispatch(fetchAllProductBrands())
    dispatch(fetchProvinces('?all=true'))
    //dispatch(fetchLocalities('?all=true'))
    dispatch(fetchAllProductSections())
    dispatch(fetchAllProductGroups())
    dispatch(fetchAllProductSubgroups())
    dispatch(fetchAllProducts())
  }, [dispatch])

  useEffect(() => {
    const constructRelations = () => {
      let relations: ProductRelations[] = [];
      productList.products?.forEach(p => {
        if (!relations.some(item => item.brandId === p.brandId && item.sectionId === p.sectionId && item.groupId === p.groupId && item.subgroupId === p.subgroupId))
          relations.push(({ brandId: p.brandId, sectionId: p.sectionId, groupId: p.groupId, subgroupId: p.subgroupId }))
      })
      return relations
    }
    if (!productList.isFetching)
      setProductRelations(constructRelations())
  }, [productList, productList.isFetching])

  useEffect(() => {
    dispatch(fetchPendingPreorder((preorder) => {
      if (preorder.id) {
        dispatch(fetchPreorder(preorder.id))
        dispatch(fetchPreorderDetails(preorder.id.toString(), undefined, '?limit=1000'))
      }
    }))
  }, [dispatch])

  useEffect(() => {
    if (prepaymentId !== undefined) {
      if (!prepaymentId) {
        dispatch(fetchInfoCurrentPriceList())
      }
      else {
        if (prepayment.prepayment && prepayment.prepayment.length > 0) {
          dispatch(fetchPriceList(prepayment.prepayment[0].codigo_listadeprecios))
        }
      }
    }
    else {
      dispatch({ type: 'INFO_CURRENT_PRICE_LIST_CLEAR' })
    }
  }, [dispatch, prepaymentId, prepayment.prepayment])

  const setLoading = () => {
    return productBrandsList.isFetching ||
      productSectionsList.isFetching ||
      productGroupsList.isFetching ||
      productSubgroupsList.isFetching ||
      currentPriceList.isFetching ||
      (prepaymentId && preoderSurplusProduct && preoderSurplusProduct.isFetching) ||
      (prepaymentId && prepayment && prepayment.isFetching) ||
      (prepaymentId && usePrepaymentDetail && usePrepaymentDetail.isFetching) ||
      session.isFetching
  }

  const getSurplusProduct = () => {
    if (preoderSurplusProduct && preoderSurplusProduct.preorderSurplusProducts && preoderSurplusProduct.preorderSurplusProducts.length > 0) { 
      return preoderSurplusProduct.preorderSurplusProducts[0]
    }
    return surplusProduct
  }  
  /*
const changeListPrice = () => {
if (currentPriceList && !currentPriceList.isFetching && currentPriceList.currentOnePriceList && !prepaymentId &&
  preorder && !preorder.isFetching && preorder.preorder && preorder.preorder.detail && preorder.preorder.detail.length > 0) {
  return setShowChangePricesDialog(currentPriceList.currentOnePriceList.codigo_listadeprecios !== preorder.preorder.detail[0].priceListId)
}
return setShowChangePricesDialog(false)
}

const handleDelete = async (preorderId: number) => {
if (preorder.preorder && preorder.preorder.detail && preorder.preorder.detail.length > 0)
  await dispatch(deleteAllPreorderDetail(preorderId))

await dispatch(deletePreorder(preorderId))
dispatch({ type: 'PREORDER_CLEAR' })
dispatch({ type: 'PREPAYMENT_CLEAR' })
dispatch({ type: 'INFO_CURRENT_PRICE_LIST_CLEAR' })

const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/dashboard`
history.push(detailUrl)
setShowChangePricesDialog(false)
}

const handleRevalue = async (preorderId: number) => {
if (preorder.preorder && preorder.preorder.detail && preorder.preorder.detail.length > 0)
  await dispatch(updatePriceBulkPreorderDetail(preorderId, preorder.preorder.detail))

await dispatch(upsertPreorder({...preorder.preorder!, priceListId: currentPriceList.currentOnePriceList?.codigo_listadeprecios! }))
dispatch({ type: 'PREORDER_CLEAR' })
dispatch({ type: 'PREPAYMENT_CLEAR' })
dispatch({ type: 'INFO_CURRENT_PRICE_LIST_CLEAR' })

const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/dashboard`
history.push(detailUrl)
setShowChangePricesDialog(false)
}

const deleteAll = async () => await handleDelete(preorder.preorder?.id!)

const revalueAll = async () => await handleRevalue(preorder.preorder?.id!)
*/

  return (
    <Stack style={{ height: 'calc(100% - var(--header-height)' }}>
      <PreorderProducts
        loading={setLoading()}
        loadingOthers={preorder.isFetching}
        priceList={currentPriceList.currentOnePriceList}
        productRelations={productRelations}
        prepaymentId={prepaymentId}
        //surplusProduct={surplusProduct}
        surplusProduct={getSurplusProduct}
        surplusQty={surplusQty}
        prepayment={(prepaymentId && prepayment.prepayment && prepayment.prepayment.length > 0 && prepayment.prepayment[0]) || undefined}
        usePrepayment={(prepaymentId && usePrepaymentDetail && usePrepaymentDetail.usePrepaymentLines && usePrepaymentDetail.usePrepaymentLines.length > 0 && usePrepaymentDetail.usePrepaymentLines) || undefined}
        productBrandsList={productBrandsList}
        productSectionsList={productSectionsList}
        productGroupsList={productGroupsList}
        productSubgroupsList={productSubgroupsList}
        provinceList={provinceList}
        //localityList={localityList}
        preorderState={preorder}
        preorderDetail={preorderDetail}
        productList={productList}
        delivery={deliveryData!}
        session={session}
      />
    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  productBrandsList: state.productBrandList,
  productSectionsList: state.productSectionList,
  productGroupsList: state.productGroupList,
  productSubgroupsList: state.productSubgroupList,
  currentPriceList: state.infoCurrentPriceList,
  preorder: state.preorderData,
  preorderDetail: state.preorderDetailList,
  prepayment: state.prepaymentDetail,
  usePrepaymentDetail: state.usePrepaymentDetail,
  productList: state.productList,
  provinceList: state.provinceList,
  //localityList: state.localityList,
  country: state.countryDetail,
  preorderSurplusProduct: state.preorderSurplusProduct,
  session: state.session
})

export default connect(mapStateToProps, null)(PreorderList)